import { DocumentServicesObject } from '@wix/document-services-types';
import {
  PLATFORM_BREAKPOINT_RANGES,
  Breakpoint,
} from '@wix/editor-platform-host-integration-apis';
import { LAYOUT } from '@wix/component-protocol/schema';
import { PlatformContext } from '../../types/platformApi';

// Resolves the breakpoint the editor is currently showing for the current page,
// falling back to the large (desktop) breakpoint when it can't be determined.
export const getCurrentBreakpoint = (
  documentServices: DocumentServicesObject,
  context: PlatformContext,
): Breakpoint => {
  const pageRef = documentServices.pages.getCurrentPage();
  const editorPointer =
    context.editorPlatformPackagesBridge.EditorPointerAPI?.buildEditorPointer(
      pageRef,
    );

  const currentBreakpoint =
    (editorPointer &&
      context.platformApiMethods.editor.stage?.getBreakpointFromPointer(
        editorPointer,
        PLATFORM_BREAKPOINT_RANGES,
      )) ??
    LAYOUT.BREAKPOINT.large;

  return currentBreakpoint;
};
